var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-center"},[_c('p',{staticClass:"flex-shrink-0"},[_vm._v("เวลาที่เหลือ")]),_c('p',{staticClass:"flex-grow-1"},[_vm._v(_vm._s(_vm.countdown))])])}
var staticRenderFns = []

export { render, staticRenderFns }